import apiClient from './api';

export const aboutService = {
  getAbout: async () => {
    const response = await apiClient.get('/about');
    // API returns { success, data }
    return response.data?.data || response.data;
  },

  getAdminAbout: async () => {
    const response = await apiClient.get('/about/admin');
    return response.data?.data || response.data;
  },

  updateAbout: async (payload) => {
    const response = await apiClient.put('/about/admin', payload);
    return response.data?.data || response.data;
  },
};

export default aboutService;
